module.exports = __webpack_public_path__ + "media/images/sp/staffs/staff_awards_title_deco-3d8ed576fab96ad092083fa4de6c1de9.svg";